import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BRAND } from '../lib/content';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 620);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-520" data-mp="3pflqol245k0b">
      {visible ? <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-navy-50 bg-white/95 px-4 py-3 backdrop-blur-md lg:hidden" data-id="element-521" data-mp="3ud56hpegm4ud">
          <div className="flex items-center gap-3" data-id="element-522" data-mp="c5pinpawvefu">
            <div className="flex-none" data-id="element-523" data-mp="gy8r67uqrjds">
              <p className="font-display text-lg font-black leading-none text-navy flex items-baseline gap-1" data-id="element-524" data-mp="gz0fcxm0eeu1">
                {BRAND.price}
                <span className="text-[10px] font-bold text-navy/60" data-id="element-525" data-mp="272pifsh4iod">{BRAND.currency}</span>
              </p>
              <p className="text-[11px] font-semibold text-navy/50 line-through" data-id="element-526" data-mp="gw78hz73eqxj">
                {BRAND.compareAtPrice}
              </p>
            </div>
            <a href={BRAND.checkoutUrl} className="flex-1 rounded-full bg-orange px-5 py-3.5 text-center font-display text-base font-extrabold text-white shadow-card active:scale-[0.98]" data-id="element-527" data-mp="c2vxdlv8znzt">
              {BRAND.ctaLabel}
            </a>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}